import { Dashboard } from 'features/Dashboard';
import { PunchupDashboard } from 'features/PunchupPages/Dashboard';
import { useAppSelector } from 'store/hooks';

const DashboardPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);
	if (isPunchup && greenZoneEnabled) return <PunchupDashboard />;
	return <Dashboard />;
};

export default DashboardPage;
